// extracted by mini-css-extract-plugin
export default {"betslipButton":"betslipButton-2OT99","innerFlexWrapper":"innerFlexWrapper-3d3kF","betButtonLabel":"betButtonLabel-2p8rh","betslipButtonV2":"betslipButtonV2-1xtXj"};